import React, { useState } from "react"
import clsx from "clsx"
import { Link } from "gatsby"

import sliceLogo from "../images/common/slice-logo.svg"
import * as Pages from "../data/seo-meta"

const Navbar = () => {
  const [menuActive, setMenuActive] = useState(false)

  const navMenuClass = clsx("nav-menu", {
    collapsed: !menuActive,
  })

  const hamburgerClass = clsx("hamburger", {
    active: menuActive,
  })

  const toggleMobileMenu = () => {
    setMenuActive(!menuActive)
  }

  return (
    <nav id="nav_top" className="navbar">
      <div className="nav-content container">
        <p className="nav-brand">
          <Link to="/">
            <img src={sliceLogo} alt="Slice Logo" />
          </Link>
        </p>
        <ul className={navMenuClass}>
          <li className="nav-item">
            <Link className="nav-item-content" to={Pages.SliceMindMeta.path}>
              Slice Mind
            </Link>
          </li>
          <li className="nav-dropdown">
            <a className="nav-item-content">Coverage</a>
            <ul className="nav-dropdown-content coverage-dropdown">
              <li className="nav-dropdown">
                <p className="nav-item-content nav-item-header industries-header">
                  Industries
                </p>
                <ul className="nav-dropdown-content industries-list">
                  {Pages.Sitemap.Industry.map((item) => (
                    <li className="nav-item" key={item.path}>
                      <Link className="nav-item-content" to={item.path}>
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li className="nav-dropdown">
                <p className="nav-item-content nav-item-header products-header">
                  Products
                </p>
                <ul className="nav-dropdown-content products-list">
                  {Pages.Sitemap.Product.map((item) => (
                    <li className="nav-item" key={item.path}>
                      <Link className="nav-item-content" to={item.path}>
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </li>
          <li className="nav-dropdown">
            <a className="nav-item-content">Corporate</a>
            <ul className="nav-dropdown-content corporate-dropdown">
              {Pages.Sitemap.Corporate.map((item) => (
                <li className="nav-item" key={item.path}>
                  {item.external ? (
                    <a
                      className="nav-item-content"
                      rel="noreferrer nofollow"
                      href={item.path}
                    >
                      {item.title}
                    </a>
                  ) : (
                    <Link className="nav-item-content" to={item.path}>
                      {item.title}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </li>
          <li className="nav-item">
            <Link className="nav-item-content" to={Pages.AgentsMeta.path}>
              Agents
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-item-content" to={Pages.ContactMeta.path}>
              Contact
            </Link>
          </li>
          <li className="lg:flex lg:items-center">
            <a
              className="mx-auto slice-button border-[--slice-primary] text-[--slice-primary] min-w-[16rem]"
              href={Pages.AgentPlatformMeta.path}
              target="_blank"
              rel="noreferrer"
            >
              Agent Login <i className="fa-solid fa-arrow-right ml-2"></i>
            </a>
          </li>
        </ul>
        <button className="nav-toggle" onClick={toggleMobileMenu}>
          <span className={hamburgerClass}>
            <span className="hamburger-bar" />
          </span>
        </button>
      </div>
    </nav>
  )
}

export default Navbar
